<template>
  <IconField>
    <template v-for="(_, slotName) in $slots" #[slotName]="slotProps">
      <slot :name="slotName" v-bind="slotProps ?? {}" />
    </template>
  </IconField>
</template>

<script setup lang="ts">
import type { IconFieldEmits, IconFieldProps } from "primevue";

import { IconField } from "primevue";

import "./pIconField.css";

defineProps</* @vue-ignore */ IconFieldProps>();
defineEmits</* @vue-ignore */ IconFieldEmits>();
</script>
